import { c as _c } from "react/compiler-runtime";
import { ProductListResponse } from '@/api/skippay/gcssProducts';
import { type InfiniteData, type UseInfiniteQueryResult } from '@tanstack/react-query';
import { ProductCard } from './ProductCard';
import { Button } from '@/components/buttons';
import { useTranslation } from 'react-i18next';
import { Fragment, useCallback, useRef } from 'react';
import { useRouter } from 'next/router';
import type { Category, SubCategory } from '@/sections/gcss/functions/utils';
interface Props {
  category?: Category | SubCategory;
  query: UseInfiniteQueryResult<InfiniteData<ProductListResponse, unknown>, Error>;
}
function SkeletonLoader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><ProductCard product={undefined} category={undefined} subcategory={undefined} page={0} /><ProductCard product={undefined} category={undefined} subcategory={undefined} page={0} /><ProductCard product={undefined} category={undefined} subcategory={undefined} page={0} /><ProductCard product={undefined} category={undefined} subcategory={undefined} page={0} /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function Results(props) {
  const $ = _c(22);
  const {
    category,
    query
  } = props;
  const {
    t
  } = useTranslation("gcss");
  const intersectionRef = useRef(null);
  const router = useRouter();
  let t0;
  if ($[0] !== query || $[1] !== router) {
    t0 = () => {
      router.push({
        query: {
          ...router.query,
          page: query.data?.pages[query.data.pages.length - 1]?.pagingInfo.nextPage
        }
      }, undefined, {
        shallow: true
      }).then(() => query.fetchNextPage());
    };
    $[0] = query;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const fetchNextPage = t0;
  const hasNextPage = query.hasNextPage;
  if (query.isPending) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <section className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"><SkeletonLoader /></section>;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== category?.path || $[5] !== query.data?.pages) {
    t1 = query.data?.pages.map((page, i) => <Fragment key={i}>{page?.data.map(product => <ProductCard key={product.id} product={product} category={category?.path[0]} subcategory={category?.path[1]} page={query.data?.pages.length} />)}</Fragment>);
    $[4] = category?.path;
    $[5] = query.data?.pages;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== query.isFetchingNextPage) {
    t2 = query.isFetchingNextPage && <SkeletonLoader />;
    $[7] = query.isFetchingNextPage;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <section className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">{t1}{t2}</section>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== fetchNextPage || $[13] !== hasNextPage || $[14] !== query.isFetchingNextPage || $[15] !== t) {
    t4 = hasNextPage && <Button analyticsParam="loadMore" testId="loadMore" variant="secondary" onClick={fetchNextPage} busy={query.isFetchingNextPage}>{t("pagination.loadMore")}</Button>;
    $[12] = fetchNextPage;
    $[13] = hasNextPage;
    $[14] = query.isFetchingNextPage;
    $[15] = t;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <div className="mt-6 flex justify-center" ref={intersectionRef}>{t4}</div>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}